// extracted by mini-css-extract-plugin
module.exports = {"dropdown_container":"dropdown_container--TeamsTimeline-Teams-routes__3dSrc","dropdownContainer":"dropdown_container--TeamsTimeline-Teams-routes__3dSrc"};